export const css = {
    root: '_1kpwOfa3',
    ' _key': 'apic-theme/apic/backview/backview'
};
export default css;
